import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/**
 * Guard that redirects to the sign-in page with query parameters preserved.
 * Adds 'fromEmptyPath=true' to distinguish deep links from explicit navigation.
 *
 * Used on the empty path route to handle OAuth redirects and deep links.
 */
export const redirectToSignInGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const queryParams = { ...route.queryParams, fromEmptyPath: 'true' };
  return router.createUrlTree(['/signin'], { queryParams });
};
